export default "__VITE_ASSET__Bg5yuty4__"